
const projects = [
    {
        id: 0,
        src: "2_1",
        title: "Photo Artist Portfolio Website",
        description: "Website created for show photographer works",
        date: "2021",
        stack: "Angular, Firebase, TypeScript, RxJS",
        tools: "Figma, Git, Postman",
        images: [
            { id: 0, src: "projects/2_1.png" },
            { id: 1, src: "projects/2_2.png" },
            { id: 2, src: "projects/2_3.png" }
        ]
    },
    {
        id: 1,
        src: "1-1",
        title: "Website for Musician",
        description: "Landing was created for tour promotion ",
        date: "2019",
        stack: "HTML/CSS, JavaScript",
        tools: "Figma, Git",
        images: [
            { id: 0, src: "projects/1-1.png" },
            { id: 1, src: "projects/1_2.png" },
            { id: 2, src: "projects/1_3.png" }
        ]
    }
];

export default projects;